import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { ButtonV2, useBreakpoint } from '@eppendorf/vnls-react-components-preview';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import { Overview } from '$components/overview-box/overview-box';
import { TabsNavigationPage } from '$components/tabs/tabs-navigation-page';
import { AddNotificationRuleDialog } from '$features/notifications/add-or-edit-notification-rule-dialog';
import { useNotificationRulesWithQueryParams } from '$features/notifications/notification-rules.api';

export function NotificationsPage() {
  const { t } = useTranslation();
  const notificationsRoutes = [
    { label: t('incidents.overview'), path: 'incidents' },
    { label: t('notificationRules.overview'), path: 'notifications-rules' },
  ];

  const isMinSm = useBreakpoint({ min: 'sm' });
  const [isNotificationDialogOpen, setIsNotificationDialogOpen] = useState(false);

  const { data: paginatedData } = useNotificationRulesWithQueryParams({
    page: 1,
    pageSize: 10,
  });
  const notificationsRules = paginatedData ? paginatedData.data : [];

  const isMaxMd = useBreakpoint({ max: 'md' });

  return (
    <Overview className={`box--mobile-fullscreen ${isMaxMd ? 'box--no-shadow' : ''}`}>
      <Overview.Header>
        <h1 className="title">{t('notificationsPage.title')}</h1>

        {notificationsRules?.length > 0 && (
          <ButtonV2
            className={`${isMinSm ? 'p-left-sm' : ''}`}
            variant="primary"
            onPress={() => setIsNotificationDialogOpen(true)}
            iconOnly={!isMinSm}
          >
            <Icon name="plus" size={IconSizeClasses.XSmall} className="bg-white" />
            {isMinSm && t('notificationRules.add')}
          </ButtonV2>
        )}
      </Overview.Header>
      <Overview.Body>
        <TabsNavigationPage routes={notificationsRoutes} />
        <div className="tab-content m-top-xl">
          <Outlet />
        </div>
      </Overview.Body>
      {isNotificationDialogOpen && (
        <AddNotificationRuleDialog
          isOpen={isNotificationDialogOpen}
          onOpenChange={(open) => setIsNotificationDialogOpen(open)}
        />
      )}
    </Overview>
  );
}
